module.exports = __webpack_public_path__ + "static/media/numbe-plate_vehicle_half.8b3dfacd.png";